import ContentstackLivePreview from '@contentstack/live-preview-utils';
import { ContentstackGatsby } from 'gatsby-source-contentstack/live-preview';

import { isLivePreviewEnabled } from 'utils/featureFlags';

const isBrowser = typeof window !== 'undefined';

let getCSData;

if (isBrowser && isLivePreviewEnabled) {
  getCSData = new ContentstackGatsby({
    api_key: process.env.CONTENTSTACK_API_KEY,
    environment: process.env.CONTENTSTACK_ENVIRONMENT,
    delivery_token: process.env.CONTENTSTACK_DELIVERY_TOKEN,
    region: process.env.CONTENTSTACK_REGION ? process.env.CONTENTSTACK_REGION : 'us',
    branch: process.env.CONTENTSTACK_BRANCH ? process.env.CONTENTSTACK_BRANCH : 'main',
    live_preview: {
      enable: process.env.CONTENTSTACK_LIVE_PREVIEW === 'true',
      preview_host: process.env.CONTENTSTACK_PREVIEW_HOST,
      preview_token: process.env.CONTENTSTACK_PREVIEW_TOKEN,
    },
    jsonRteToHtml: true,
  });

  getCSData.setHost(process.env.CONTENTSTACK_CDN_HOST);

  ContentstackLivePreview.init({
    stackSdk: getCSData.stackSdk,
    clientUrlParams: {
      host: process.env.CONTENTSTACK_APP_HOST,
    },
  });
}

export { getCSData };
